









import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ICalculationExpressionBehavior, IConditionalExpressionContent, ExpressionKinds } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";
import { CalculateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";

@Component
export default class CalculationConditionalExpressionBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (write: (source: ICalculationExpressionBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICalculationExpressionBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get contents(): IConditionalExpressionContent[] {
    return this.readPropertyOrDefault(s => s.conditionalExpressionBehavior.contents, []);
  }

  set contents(value: IConditionalExpressionContent[]) {
    this.writePropertyWhenValid(s => s.conditionalExpressionBehavior = { contents: value });
  }

  get selectionObjects(): IFormatObjectEditable[] {
    return Enumerable.from(this.commonComponents.currentPage.getObjects())
      .where(o => this.conditionsOfEachElementType(o))
      .toArray();
  }

  private conditionsOfEachElementType(object: IFormatObjectEditable): boolean {
    const linkedObject = object.toLinkedObjectIdentifier();
    switch (object.objectTypeName().getValue()) {
      case "text":
      case "tag":
      case "scriptlink":
      case "jointext":
      case "combo":
      case "roll":
        return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "";
      case "check":
      case "circleselect":
        return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "" && !!linkedObject.subKey && linkedObject.subKey !== "";
      case "script":
        return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "" && !!linkedObject.tableIndex && linkedObject.tableIndex.row === 0 && linkedObject.tableIndex.column === 0;
      case "calculate":
        const kind = (object instanceof CalculateObjectEditor) ? object.kind().getValue() : null;
        return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "" && (kind === ExpressionKinds.Calculation || kind === ExpressionKinds.DateDuration);
      default:
        return false;
    }
  }

  async showCalculationConditionalExpressionContentEditDialog() {
    const dialog = this.commonComponents.getDialogs().getCalculationConditionalExpressionContentEditDialog();
    const expressionContents = await dialog.show(this.contents, this.selectionObjects);
    if (!expressionContents) { return; }
    this.contents = expressionContents;
  }
}
